module.exports = __webpack_public_path__ + "img/sw-ys21.256d2747.jpg";